import styles from './GlobalStrip.module.css';

const NUM_BLOCKS = 24;

const getBlockColor = (position) => {
    if (position < 0.60) return '#22c55e';
    if (position < 0.85) return '#fb923c';
    return '#ef4444';
};

const formatValue = (value) => Number(value).toFixed(1);

export default function GlobalStrip({
    connected,
    status,
    portName,
    onConnect,
    onDisconnect,
    cpuMin,
    cpuAvg,
    cpuMax,
    masterOutLeft,
    masterOutRight
}) {
    // Disconnected state - just show connect button
    if (!connected) {
        return (
            <div className={styles.strip}>
                <div className={styles.disconnectedContent}>
                    <span className={styles.title}>Orbiton</span>
                    <div className={styles.connectionArea}>
                        <span className={`${styles.indicator} ${styles.disconnected}`}>●</span>
                        <span className={styles.statusText}>{status}</span>
                        <button onClick={onConnect} className={styles.connectBtn}>
                            Connect
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Connected state - show all meters
    return (
        <div className={styles.strip}>
            {/* Connection status - far left */}
            <div className={styles.connectionStatus}>
                <span className={`${styles.indicator} ${styles.connected}`}>●</span>
                <span className={styles.portName}>{portName}</span>
                <button onClick={onDisconnect} className={styles.disconnectBtn}>
                    ✕
                </button>
            </div>

            {/* CPU Section */}
            <div className={styles.section}>
                <span className={styles.label}>CPU</span>
                <div className={styles.cpuMeter}>
                    <div className={styles.cpuBar}>
                        <div
                            className={styles.cpuFill}
                            style={{ width: `${cpuAvg}%` }}
                        />
                        <div
                            className={styles.cpuTickMin}
                            style={{ left: `${cpuMin}%` }}
                        />
                        <div
                            className={styles.cpuTickMax}
                            style={{ left: `${cpuMax}%` }}
                        />
                    </div>
                    <div className={styles.cpuValues}>
                        <span className={styles.cpuValueMin}>{formatValue(cpuMin)}%</span>
                        <span className={styles.cpuValueAvg}>{formatValue(cpuAvg)}%</span>
                        <span className={styles.cpuValueMax}>{formatValue(cpuMax)}%</span>
                    </div>
                </div>
            </div>

            {/* Spacer */}
            <div className={styles.spacer} />

            {/* Title */}
            <span className={styles.titleConnected}>Orbiton</span>

            {/* Spacer */}
            <div className={styles.spacer} />

            {/* Master Out Section */}
            <div className={styles.section}>
                <span className={styles.label}>Master Out</span>
                <div className={styles.stereoMeter}>
                    <div className={styles.stereoChannel}>
                        <span className={styles.channelLabel}>L</span>
                        <div className={styles.stereoBar}>
                            {[...Array(NUM_BLOCKS)].map((_, i) => {
                                const blockThreshold = (i + 1) / NUM_BLOCKS;
                                const blockPosition = i / (NUM_BLOCKS - 1);
                                const isActive = masterOutLeft >= blockThreshold;
                                const color = getBlockColor(blockPosition);
                                return (
                                    <div
                                        key={`left-${i}`}
                                        className={`${styles.block} ${isActive ? styles.active : ''}`}
                                        style={{ '--block-color': color }}
                                    />
                                );
                            })}
                        </div>
                        <span className={styles.levelValue}>{(masterOutLeft * 100).toFixed(0)}%</span>
                    </div>
                    <div className={styles.stereoChannel}>
                        <span className={styles.channelLabel}>R</span>
                        <div className={styles.stereoBar}>
                            {[...Array(NUM_BLOCKS)].map((_, i) => {
                                const blockThreshold = (i + 1) / NUM_BLOCKS;
                                const blockPosition = i / (NUM_BLOCKS - 1);
                                const isActive = masterOutRight >= blockThreshold;
                                const color = getBlockColor(blockPosition);
                                return (
                                    <div
                                        key={`right-${i}`}
                                        className={`${styles.block} ${isActive ? styles.active : ''}`}
                                        style={{ '--block-color': color }}
                                    />
                                );
                            })}
                        </div>
                        <span className={styles.levelValue}>{(masterOutRight * 100).toFixed(0)}%</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
